import { render, staticRenderFns } from "./DialogAddKeyword.vue?vue&type=template&id=56d0d1b2"
import script from "./DialogAddKeyword.vue?vue&type=script&lang=js"
export * from "./DialogAddKeyword.vue?vue&type=script&lang=js"
import style0 from "./DialogAddKeyword.vue?vue&type=style&index=0&id=56d0d1b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports